import React from 'react';
import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const Content = styled.div`
  background: white;
  border-radius: 8px;
  padding: 24px;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
`;

const Header = styled.div`
  margin-bottom: 16px;
`;

const Title = styled.h2`
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
`;

const Description = styled.p`
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.4;
`;

const Footer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;
`;

const Button = styled.button`
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid;
  
  ${props => props.variant === 'primary' ? `
    background-color: #FF7F00;
    color: white;
    border-color: #FF7F00;
    
    &:hover {
      background-color: #e66f00;
      border-color: #e66f00;
    }
  ` : `
    background-color: white;
    color: #333;
    border-color: #ccc;
    
    &:hover {
      background-color: #f5f5f5;
    }
  `}
`;

const AlertDialog = ({ open, onOpenChange, children }) => {
  if (!open) return null;
  
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onOpenChange(false);
    }
  };
  
  return (
    <Overlay onClick={handleOverlayClick}>
      <Content>
        {children}
      </Content>
    </Overlay>
  );
};

const AlertDialogTrigger = ({ children, ...props }) => {
  return React.cloneElement(children, props);
};

const AlertDialogContent = ({ children }) => children;

const AlertDialogHeader = ({ children }) => (
  <Header>{children}</Header>
);

const AlertDialogTitle = ({ children }) => (
  <Title>{children}</Title>
);

const AlertDialogDescription = ({ children }) => (
  <Description>{children}</Description>
);

const AlertDialogFooter = ({ children }) => (
  <Footer>{children}</Footer>
);

const AlertDialogAction = ({ children, onClick, ...props }) => (
  <Button variant="primary" onClick={onClick} {...props}>
    {children}
  </Button>
);

const AlertDialogCancel = ({ children, onClick, ...props }) => (
  <Button onClick={onClick} {...props}>
    {children}
  </Button>
);

export {
  AlertDialog,
  AlertDialogTrigger,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogAction,
  AlertDialogCancel,
};